export default __webpack_public_path__ + "static/media/logo.b5905135.png";